import React from 'react';
import { useNavigate } from 'react-router-dom';
import { mockCargoCategories } from '../mockData';

const CargoCategories = () => {
  const navigate = useNavigate();

  const handleCategoryClick = (category) => {
    // Navigate to browse loads with category filter
    navigate(`/browse-loads?category=${encodeURIComponent(category)}`);
  };

  return (
    <div 
      className="py-12 sm:py-16 md:py-20 bg-cover bg-center relative"
      style={{ backgroundImage: 'linear-gradient(rgba(30, 58, 95, 0.9), rgba(30, 58, 95, 0.9)), url(https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?w=1920)' }}
    >
      <div className="container mx-auto px-4 sm:px-6">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white text-center mb-3 sm:mb-4">Cargo Categories</h2>
        <p className="text-white text-center text-base sm:text-lg mb-8 sm:mb-12">Find the transportation for you:</p>
        
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-3 sm:gap-4">
          {mockCargoCategories.map((category, index) => (
            <button
              key={index}
              onClick={() => handleCategoryClick(category)}
              className="bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white px-3 sm:px-4 py-2 sm:py-3 rounded-lg text-center transition-all hover:scale-105 border border-white/20 text-xs sm:text-sm cursor-pointer"
            >
              {category}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CargoCategories;